import { BreadcrumbLoader } from "../../../../decorators/BreadcrumbLoader";
import { BreadcrumbNameLoader } from "../../../../services/breadcrumbs/breadcrumbLoaders/breadcrumbNameLoaders/BreadcrumbNameLoader";
import { texts } from "../../../../i18n/texts";

@BreadcrumbLoader("/project-analysis")
export class AdminViewProjectAnalysisBreadcrumbNameLoader extends BreadcrumbNameLoader {
  name = texts.adminView.projectAnalysis;
}
